import axios, { AxiosPromise } from 'axios';
import {
  WatcherLight,
  WatcherContent,
  NewWatcherQueryParams,
  WatcherEntityItem,
  NewWatcherFromSuggestionQueryParams,
  NewWatcherEntityQueryParams,
} from './watchers.types';
import { USER_ONBOARDING } from '../../../shared/constants/userOnboardingConstants';

export async function fetchWatchers(params: {
  from?: number;
  size?: number;
}): Promise<Array<WatcherLight>> {
  return (await axios.get('/search_watch/list', { params })).data;
}

export async function createWatcherRequest(
  queryParams:
    | NewWatcherQueryParams
    | NewWatcherFromSuggestionQueryParams
    | NewWatcherEntityQueryParams,
): Promise<{ alreadyExists?: boolean; key: string }> {
  return (await axios.post('/search_watch/create', queryParams)).data;
}

export function deleteWatcherRequest(key: string): Promise<{}> {
  return axios.post('/search_watch/delete', { key });
}

export async function fetchWatcherContent(params: {
  key: string;
  from: number;
  size: number;
}): Promise<WatcherContent> {
  return (await axios.get('/search_watch/content', { params })).data;
}

export async function fetchWatcher(key: string): Promise<WatcherLight> {
  return (
    await axios.get('/search_watch/get', {
      params: { key },
    })
  ).data;
}

export function markAllWatcherDecisionsAsRead(
  key: string,
): AxiosPromise<{ key: string }> {
  return axios.post('/search_watch/mark_all_as_read', {
    key,
  });
}

export async function openedWatcher(key: string): Promise<Array<number>> {
  return (await axios.post('/opened_watcher', { key })).data;
}

export function getUserWatchers(): AxiosPromise<Array<WatcherEntityItem>> {
  return axios.get('/search_watch/listEntities');
}

export function setOnboardingSeeWatchersStatus() {
  axios.post('/setOnboardingStatus', {
    type: USER_ONBOARDING.SEE_WATCHERS_INBOX,
  });
}
